// extracted by mini-css-extract-plugin
module.exports = {"desktop":"1440","laptop":"1024","mobile":"375","tablet":"768"};